import React from 'react';
import { observer } from 'mobx-react';

// Helpers
import { checkValidity, closeDrawer } from '../../helpers/helpers.js';

// Translations
import translate from '../Translate.js';

// Components
import Step from '../Common/Step';
import EditEnrollmentSection from './EditEnrollmentSection';

// Dependencies
import moment from 'moment';

const EnrollmentException = observer(class EnrollmentException extends React.Component {
  constructor() {
    super();
    this.setStep = this.setStep.bind(this);
    this.nextStep = this.nextStep.bind(this);
    this.prevStep = this.prevStep.bind(this);
    this.handleInput = this.handleInput.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.complete = this.complete.bind(this);
    this.momentFormat = this.momentFormat.bind(this);
  }

  componentWillMount() {
    let configurationSid = this.props.configurationSid;

    this.state = {
      step: 1,
      enrollmentSid: this.props.routing.location.query.enrollment,
      configurationSid,
      skippable: false
    }

    this.getFilteredProctorTypes();

    // Get insitution settings so we can only show allowed permitted items
    this.props.store.SettingsStore.getInstituteSettings(this);
  }

  getFilteredProctorTypes() {
    this.props.store.SessionStore.getProctorGroupTypes();
  }

  setStep(e, step) {
    e.preventDefault();
    this.setState({
      step
    });
  }

  nextStep() {
    this.setState({
      step: this.state.step + 1
    });
  }

  prevStep() {
    this.setState({
      step: this.state.step - 1
    });
  }

  renderDefault() {
    return '';
  }

  defaultDiff() {
    return '';
  }

  handleInput(name, e, isConfiguration, date, time, isCheckbox, array) {
    let data = null;
    let value = null;

    if(e) {
      value = e.target.value;
    }

    // Make sure boolean values are boolean
    if(value === 'true') {
      value = true;
    }
    if(value === 'false') {
      value = false;
    }

    // If we’re updating a date, we need to format it
    if(date) {
      date = moment(date).format('YYYY-MM-DD Z');
      value = moment(`${date} ${time}`, 'YYYY-MM-DD Z HH:mm').toISOString();
    }

    // If it’s a checkbox, get the checked state
    if(isCheckbox) {
      value = e.target.checked;
    }

    // If the data provided is an array
    if(array) {
      value = array;
    }

    data = {
      [name]: value
    };

    this.props.store.EnrollmentStore.updateConfigurationData(data);
  }

  handleSubmit(exit) {
    const { translation } = this.props;
    const configuration = this.props.store.EnrollmentStore.enrollmentConfiguration;

    // Don’t submit until the last step
    if(this.state.step === translation.steps.length || exit === true) {
      let callback = this.complete;

      // Make sure at least 1 proctor type has been chosen
      if(configuration.proctorTypes.length > 0) {
        if(!this.props.configurationSid) {
          // If we’re not editing, create a configuration
          this.props.store.EnrollmentStore.createEnrollmentConfiguration(this.props.userSid, this.props.enrollmentSid, callback);
        } else {
          // Otherwise, update the configuration
          this.props.store.EnrollmentStore.updateEnrollmentConfiguration(this.props.userSid, this.props.enrollmentSid, this.props.configurationSid, callback);
        }
      } else {
        const dialogContent = translation.proctor_warning;
        this.props.store.SessionStore.showDialog(dialogContent);
      }
    } else {
      this.nextStep();
    }
  }

  complete(sid) {
    const { translation } = this.props;

    closeDrawer(null, this.props.parent);
    this.props.store.SessionStore.showToaster(translation.configuration_saved, 'success');
  }

  momentFormat(date) {
    const { userTimezone } = this.props.store.SessionStore;
    return moment.utc(date).tz(userTimezone).format('M/D/YYYY [at] h:mma z');
  }

  render() {
    const { translation } = this.props;
    const { SessionStore } = this.props.store;
    let steps = [...translation.steps];

    if(!SessionStore.loading) {
      return(
        <div className="drawer__content">
          <header className="drawer__header">
            <div className="wrap">
              <h1 className="drawer__title">{translation.heading}</h1>
            </div>
          </header>

          <div className="wrap block-form">
            <Step
              step={this.state.step}
              setStep={this.setStep}
              data={steps}
              skippable={this.state.skippable}
            />

            <form className="exam-form panel" onSubmit={(e) => checkValidity(e, this.handleSubmit, 'form.exam-form')} noValidate>
              <div className="panel__header">
                <h3 className="panel__title"><legend>{steps[this.state.step - 1]}</legend></h3>
              </div>

              <div className="panel__body">
                <EditEnrollmentSection
                  step={this.state.step}
                  nextStep={this.nextStep}
                  prevStep={this.prevStep}
                  renderDefault={this.renderDefault}
                  defaultDiff={this.defaultDiff}
                  {...this.props}
                  enrollmentConfig={true}
                  handleInput={this.handleInput}
                />

                <div className="panel__actions actions">
                  {this.state.configurationSid && !this.props.approval &&
                    <button
                      className="actions__btn actions__btn--secondary actions__btn--offset"
                      type="button"
                      onClick={(e) => checkValidity(e, () => this.handleSubmit(true), 'form.exam-form')}
                    >
                      {translation.save_and_exit}
                    </button>
                  }

                  {this.state.step > 1 &&
                    <button
                      className="actions__btn actions__btn--secondary"
                      type="button"
                      onClick={this.prevStep}
                    >
                      {translation.back}
                    </button>
                  }

                  <button className="actions__btn actions__btn--primary">{translation.continue}</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      );
    }

    return null;
  }
})

export default translate('EnrollmentException')(EnrollmentException);


// WEBPACK FOOTER //
// ./src/app/components/ExamEdit/EnrollmentException.js